const filterOperators = [
    { value: "equal", payloadRequired: true, isBooleanOperator: true, isBooleanHourOperator: true },
    { value: "not_equal", payloadRequired: true, isBooleanOperator: true },
    { value: "contain", payloadRequired: true },
    { value: "not_contain", payloadRequired: true },
    { value: "starts_with", payloadRequired: true },
    { value: "ends_with", payloadRequired: true },
    { value: "empty", payloadRequired: false },
    { value: "non_empty", payloadRequired: false },
    { value: "longer_than", isNumeric: true, payloadRequired: true },
    { value: "shorter_than", isNumeric: true, payloadRequired: true },
    { value: "less_than", isNumeric: true, payloadRequired: true, isBooleanHourOperator: true },
    { value: "less_or_equal", isNumeric: true, payloadRequired: true, isBooleanHourOperator: true },
    { value: "greater_than", isNumeric: true, payloadRequired: true, isBooleanHourOperator: true },
    { value: "greater_or_equal", isNumeric: true, payloadRequired: true, isBooleanHourOperator: true },
];

export default filterOperators;
